import { useCallback, useRef } from 'react';

/**
 * Descarta las respuestas atrasadas: sólo la ÚLTIMA petición pinta.
 *
 * Por qué existe (6-oct-2026): Agentes mostraba todo el histórico —y a Tanya—
 * con la barra puesta en dos días. El backend filtraba bien; la pantalla hacía
 * dos peticiones, una sin filtros (el estado inicial, antes de que la barra
 * emitiera) y otra con ellos, y la de todo el histórico tardaba más (460 ms
 * contra 190 ms en producción): llegaba al final y pisaba la buena. Lo mismo
 * pasa al mover dos fechas seguidas. No hay error ni número raro: hay una
 * tabla verosímil que no corresponde a los filtros que se ven.
 *
 * Uso:
 *   const nuevaPeticion = usePeticionVigente();
 *   const fetchAll = useCallback((params) => {
 *     const vigente = nuevaPeticion();
 *     getAlgo(params).then((r) => { if (vigente()) setAlgo(r.data); });
 *   }, [nuevaPeticion]);
 */
export function usePeticionVigente() {
  const ultima = useRef(0);
  return useCallback(() => {
    const id = ++ultima.current;
    return () => id === ultima.current;
  }, []);
}
